// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Map', {toJSON: require('./$.collection-to-json')('Map')});


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/~/core-js/library/modules/es7.map.to-json.js
 ** module id = 311
 ** module chunks = 0
 **/